import PublicService from '@/service/public'
import { openChat } from '@/data/im'

export const layoutToConsult = async(building_id, from = '', layout_id = '') => {
    const consultant = await PublicService.getRecommendConsultant({
        scene: 'layout',
        building_id,
    })
    openChat(consultant.id, {
        from,
        building_id,
        layout_id
    })
}